import { Container } from 'react-bootstrap';


import HostTripEditButtons from './HostTripEditButtons';
import styles from './TripHeader.module.scss';
import TripHeaderInfoSection from './TripHeaderInfoSection';
import TripImages from './TripImages';
import useTripsDiscountRate from './useTripsDiscountRate';
import { TripsPageQuery } from '@website/types/graphqlOperations';
import TrustPilotWidget from '@website/components/trustpilot/TrustPilotWidget';

type TripHeaderProps = {
  trip: TripsPageQuery['tripByURL'];
};

export default function TripHeader({ trip }: TripHeaderProps) {
  const discountRate = useTripsDiscountRate(trip);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.tripHeader}>
          {(trip.overlayText || trip.minimumPrice?.priceBeforeDiscount) && (
            <div className={`${styles.ribbon}`}>
              <span>
                {discountRate
                  ? `ON SALE: Save ${discountRate}%`
                  : trip.overlayText}
              </span>
            </div>
          )}
          <div className="py-3 w-100 px-3">
            <h1 className={`h-2 ${styles.tripTitle}`}>{trip.title}</h1>

            <TripHeaderInfoSection trip={trip} />
          </div>

          <div
            className="bg-light"
            style={{
              position: 'relative',
            }}
          >
            <TripImages trip={trip} />
          </div>
          <div className={styles.subtitleContainer}>
            <Container className="mx-auto">
              <p className={`${styles.subtitle} h5 fw-normal`}>
                {trip.description}
              </p>
              <p>
                <TrustPilotWidget
                  templateId="5419b6ffb0d04a076446a9af"
                  height="20px"
                  className="mx-auto"
                />
              </p>
            </Container>
          </div>
        </div>
      </div>
      <HostTripEditButtons
        url={trip.urlSlug}
        hostUrlSlug={trip.host?.urlSlug}
      />
    </>
  );
}
